var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 6.66658C10.9166 6.66658 11.6666 5.91658 11.6666 4.99992C11.6666 4.08325 10.9166 3.33325 9.99992 3.33325C9.08325 3.33325 8.33325 4.08325 8.33325 4.99992C8.33325 5.91658 9.08325 6.66658 9.99992 6.66658ZM9.99992 8.33325C9.08325 8.33325 8.33325 9.08325 8.33325 9.99992C8.33325 10.9166 9.08325 11.6666 9.99992 11.6666C10.9166 11.6666 11.6666 10.9166 11.6666 9.99992C11.6666 9.08325 10.9166 8.33325 9.99992 8.33325ZM9.99992 13.3333C9.08325 13.3333 8.33325 14.0833 8.33325 14.9999C8.33325 15.9166 9.08325 16.6666 9.99992 16.6666C10.9166 16.6666 11.6666 15.9166 11.6666 14.9999C11.6666 14.0833 10.9166 13.3333 9.99992 13.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.1c86a91299b360b1724fa3634a984eea.svg";
export { ForwardRef as ReactComponent };